import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpcVideoTypeShape",
  "use": "svg-icon-cpcVideoTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpcVideoTypeShape\"><path d=\"M0 15V.999h16V15H0zm2-2h12V2.999H2V13zm4-7.554a.451.451 0 0 1 .693-.374l3.955 2.555a.446.446 0 0 1 0 .747L6.693 10.93a.457.457 0 0 1-.457.017.444.444 0 0 1-.236-.393V5.446z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol